import React, {Component} from "react";
import PropTypes from "prop-types";
import Input from "react-toolbox/lib/input/Input";
import "./Signin.css";
import Button from "react-toolbox/lib/button/Button";
import { LoginStates } from "../App";
import { Link } from "react-router-dom";
import ErrorComponent from "./ErrorComponent.js";

class Signin extends Component {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.login = this.login.bind(this);
		this.state = {name: props.defaultUserID, password: ""};
	}
	
	handleChange(name, value) {
		this.setState({[name]: value});
	}

	handleSubmit(event) {
		event.preventDefault();
		this.login();
	}

	login() {
		this.props.loginFunction(this.state.name, this.state.password);
	}

	render() {
		let errorComponent;
		switch(this.props.loginState) {
		case LoginStates.loggedOut:
			errorComponent = null;
			break;
		case LoginStates.inProgress:
			errorComponent = null;
			//TODO: Need a spinner somewhere
			return <h2>Logging In...</h2>;
		case LoginStates.failed:
			switch (this.props.lastResultCode) {
			case 401:
				errorComponent = <p className="LoginErrorText">The user name or password you entered was incorrect.</p>;
				break;
			default:
				errorComponent = <ErrorComponent processDescription="trying to sign in" errorMsg={this.props.lastResultDetail}/>;
				return errorComponent;
			}
			break;
		case LoginStates.appInitializing:
			errorComponent = null;
			//TODO: Spinner?
			return <h2>Initializing...</h2>;
		default: 
			errorComponent = <ErrorComponent processDescription="preparing to log in" errorMsg={"Unexpected login state: "+this.props.loginState}/>;
			return errorComponent;
		}
		return(
			<div className="LoginForm">
				<form onSubmit={this.handleSubmit}>
					<h2>Sign In to Your Account</h2>
					{errorComponent}
					<Input type="text" name="userid" value={this.state.name} label="User ID" onChange={this.handleChange.bind(this, "name")}/>
					<Input type="password" name="password" value={this.state.password} label="Password" onChange={this.handleChange.bind(this, "password")}/>
					<Button raised primary label="Sign In" type="submit" onClick={this.login} />
				</form>
				<div className="loginAlternatives">
					<p>
						<span>Don&rsquo;t have an account yet?</span><br/>
						<Link to="/signup">Create an account.</Link>
					</p>
					<p>
						<span>Can&rsquo;t remember your password?</span><br/>
						<Link to="/resetpassword">Reset your password.</Link>
					</p>
					<p>
						<span>Can&rsquo;t remember your user name?</span><br/>
						<Link to="/contact">Contact us</Link>.
					</p>
				</div>
			</div>
		);
	}
}

Signin.propTypes = {
	loginState: PropTypes.number,
	loginFunction: PropTypes.func,
	lastResultCode: PropTypes.number,
	lastResultDetail: PropTypes.string,
	defaultUserID: PropTypes.string
};

export default Signin;


// WEBPACK FOOTER //
// ./src/components/Signin.js